import React, { useEffect } from "react";
import { Button, TagPicker, DatePicker } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "rsuite/dist/rsuite.min.css";
import { useDispatch, useSelector } from "react-redux";
import "moment/locale/pt-br";

import {
  allHorariosVans,
  removeHorarioVans,
  updateHorarioVans,
  addHorariosVans,
  filterHorariosVans,
} from "../../store/modules/vans/actions";

export default function Vans() {
  const dispatch = useDispatch();
  ///const { horario,  form } = useSelector((state) => state.horario);
  const { horario, form, vansReservadas, vans_user, components } = useSelector(
    (state) => state.Vans
  );

  const setHorario = (key, value) => {
    dispatch(
      updateHorarioVans({
        horario: { ...horario, [key]: value },
      })
    );
  };

  const save = (vans) => {
    dispatch(
      updateHorarioVans({
        horario: vans,
      })
    );
    dispatch(addHorariosVans());
    setTimeout(() => {
    
      dispatch(filterHorariosVans());
    }, 5000);

  };
  const cancelar = (vans) => {
    dispatch(
      updateHorarioVans({
        id_extratime: vans,
      })
    );
    dispatch(removeHorarioVans());
    setTimeout(() => {
    
      dispatch(filterHorariosVans());
    }, 5000);
  };


  const diasDaSemana = [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sabado",
  ];
  useEffect(() => {
    dispatch(allHorariosVans());
    dispatch(filterHorariosVans());
  }, [])
  


  return (
    <div>
      <div className="d-flex flex-column text-white">
        <div className="d-flex flex-row justify-content-between ">
          <div className="d-flex flex-row col-10 p-1">
            <h3>Pesquisar horarios</h3>
          </div>

          <div>
        
          </div>
        </div>

        <div>
          {vansReservadas
            ? vansReservadas.length > 0
              ? vansReservadas.map((van) => {
                  return (
                    <div className="d-flex flex-row col-12  ">
                      <div className="d-flex flex-row col-11 m-1   align-items-center justify-content-between card bg-black ">
                        <div className="d-flex align-items-start ">
                          <b className="p-1">{van.name}</b>
                          <input
                            type="text"
                            className="form-control "
                            placeholder="Name"
                            disabled={form.disabled}
                            value={van.name}
                          />
                        </div>
                        <div className="d-flex m-1 ">
                          <button
                            className=" btn btn-primary "
                            onClick={() => {
                              save(van);
                            }}
                          >
                            Reservar horario vans
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              : ""
            : ""}
        </div>

        <div className=" text-white    bg-dark mt-1 text-center col-12 ">
          <div className="mt-2">
            <b className="  text-center  ">Vans reservadas</b>
          {  components.confirmDelete === true?
(            <div class="alert alert-success" role="alert">
                            Reserva canselada
                          </div>): ""}
                          {console.log(components.confirmDelete)}
            <div>
              {vans_user
                ? vans_user.length > 0
                  ? vans_user.map((van) => {
                      return (
                        <div className="d-flex flex-row col-12  ">
                          
                          <div className="d-flex flex-row col-11 m-1   align-items-center justify-content-between card bg-black ">
                         
                            <div className="d-flex align-items-start ">
                              
                              <b className="p-1">{van.extraTime.name}</b>
                              <input
                                type="text"
                                className="form-control "
                                placeholder="Name"
                                disabled={form.disabled}
                                value={van.extraTime.name}
                              />
                            </div>
                            <div className="d-flex m-1 ">
                              <button
                                className=" btn btn-danger "
                                onClick={() => {
                                  cancelar(van);
                                }}
                              >
                                Cancelar reserva
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : ""
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
